import { useEffect, useState } from "react";
import { api, API, fmtGBP, APP_TYPE_LABELS, INTERNAL_STAGE_LABELS } from "../../api";
import { PageHeader, Panel } from "../../ui";

export default function ReportsPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`${API}/reports/summary`).then(({ data }) => setData(data)); }, []);
  if (!data) return <p className="text-sm text-slate-500">Loading…</p>;
  return (
    <div>
      <PageHeader title="Reports" subtitle="Snapshot across the agency." />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-6">
        <Panel className="p-5"><p className="text-[11px] uppercase tracking-[0.14em] text-slate-500">Missing documents</p><p className="font-serif text-3xl mt-1">{data.missing_documents}</p></Panel>
        <Panel className="p-5"><p className="text-[11px] uppercase tracking-[0.14em] text-slate-500">Expected fees</p><p className="font-serif text-3xl mt-1">{fmtGBP(data.expected_fees)}</p></Panel>
        <Panel className="p-5"><p className="text-[11px] uppercase tracking-[0.14em] text-slate-500">Received fees</p><p className="font-serif text-3xl mt-1 text-emerald-700">{fmtGBP(data.received_fees)}</p></Panel>
      </div>
      <Panel className="p-5">
        <h3 className="font-serif text-lg mb-3">Applications by type & stage</h3>
        <ul className="divide-y divide-slate-100 text-sm">
          {data.applications_by_type_and_stage.map((row, i) => (
            <li key={i} className="py-2 flex items-center justify-between">
              <span>{APP_TYPE_LABELS[row._id.type] || row._id.type} · {INTERNAL_STAGE_LABELS[row._id.status] || row._id.status}</span>
              <span className="font-semibold">{row.count}</span>
            </li>
          ))}
          {data.applications_by_type_and_stage.length === 0 && <li className="py-4 text-center text-slate-500">No applications yet.</li>}
        </ul>
      </Panel>
    </div>
  );
}
